//default PTS structure template, When creating a new kiinteistökortti.
export function createDefaulPTS() {
  const templates = {
    "Tutkimustarpeet": [
      { name: "Tutkimustarpeet", items: [{ label: "" }] }
    ],
    "Rakennetekniikka": [
      { name: "Vierustat ja kuivatusosat", items: [{ label: "" }] },
      { name: "Pihapäällysteet", items: [{ label: "" }] },
      { name: "Aluevarusteet ja -rakenteet", items: [{ label: "" }] },
      { name: "Perustukset ja sokkelit", items: [{ label: "" }] },
      { name: "Alapohja", items: [{ label: "" }] },
      { name: "Rakennusrunko", items: [{ label: "" }] },
      { name: "Ulkoseinät", items: [{ label: "" }] },
      { name: "Ikkunat", items: [{ label: "" }] },
      { name: "Ulko-ovet", items: [{ label: "" }] },
      { name: "Parvekkeet", items: [{ label: "" }] },
      { name: "Kattorakenteet", items: [{ label: "" }] },
      { name: "Sisätilat", items: [{ label: "" }] },
      { name: "Märkätilat", items: [{ label: "" }] },
    ],
    "LVI Järjestelmät": [
      { name: "Lämmöntuotanto", items: [{ label: "" }] },
      { name: "Lämmitysverkosto", items: [{ label: "" }] },
      { name: "Vesijohtoverkosto", items: [{ label: "" }] },
      { name: "Viemäriverkosto", items: [{ label: "" }] },
      { name: "Ilmanvaihtojärjestelmä", items: [{ label: "" }] },
      { name: "Jäähdytysjärjestelmät", items: [{ label: "" }] },
      { name: "Rakennusautomaatio", items: [{ label: "" }] },
      { name: "Muut järjestelmät", items: [{ label: "" }] },
    ],
    "Sähköjärjestelmät": [
      { name: "Aluesähköistys", items: [{ label: "" }] },
      { name: "Kytkinlaitokset ja jakokeskukset", items: [{ label: "" }] },
      { name: "Johdot ja niiden varusteet", items: [{ label: "" }] },
      { name: "Valaisimet, lämmittimet, kojeet ja laitteet", items: [{ label: "" }] },
      { name: "Tele- ja antennijärjestelmät", items: [{ label: "" }] },
      { name: "Palo- ja turvajärjestelmät", items: [{ label: "" }] },
      { name: "Siirtolaitteet", items: [{ label: "" }] },
    ],
  };

  const entries = [];
  Object.entries(templates).forEach(([category, sections]) => {
    sections.forEach(section => {
      section.items.forEach(item => {
        entries.push({
          category,
          section: section.name,
          label: item.label || "",
          kl_rating: null,
          values_by_year: {},
          metadata: {},
        });
      });
    });
  });
  return entries;
}
